import Vue from "vue";
import { Validator } from "vee-validate";

export default {
  ["SET_WHOLESALE_STATUS"]: function(state, value) {
    state.isWholesale = value;
  },
  ["SET_WHOLESALE"]: function(state, value) {
    state.wholesale = value;
  },
  ["SET_PRODUCT_IN_CART"]: function(state, product) {
    Vue.set(state.cart[product.index], "quantity", product.quantity);
  },
  ["SET_LANG"]: function(state, payload) {
    Vue.i18n.set(payload);
    Validator.localize(payload);
  },
  ["SET_THEME_COLOR"]: function(state, payload) {
    state.theme.color = payload ? payload : "#cecece";
  },
  ["SET_ALL_CART"]: function(state, payload) {
    state.cart = payload;
  },
  ["SET_INFLUENCER_ID"]: function(state, payload) {
    state.influencerid = payload;
    localStorage.setItem("influencerid", payload);
  },
  ["CLEAR_INFLUENCER_ID"]: function(state) {
    state.influencerid = null;
    localStorage.removeItem("influencerid");
  },
  ["ADD_CART"]: function(state, payload) {
    state.cart.push(payload);
  },
  ["EDIT_QUANTITY"]: function(state, payload) {
    state.cart[payload.index].quantity = payload.quantity;
  },
  ["UPDATE_BUNDLE_CART"]: function(state, payload) {
    state.cart.forEach(function(product, index) {
      var bundles = [];
      bundles = payload.filter(function(bundle) {
        if (bundle.productid == product.id) {
          return bundle;
        }
      });
      Vue.set(state.cart[index], "productbundle", bundles);
    });
  },
};
